import styled from "styled-components";

const HealthQuery = () => {
  return (
    <Card>
      <h3 style={{ textAlign: "center", fontWeight: 600 }}>
        Queries on Health & Diseases
      </h3>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: "2%",
        }}
      >
        <QueryCard>
          <img src="/img/Group 27398.svg" alt="" />
          <TextBox>
            <em>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet,
                dolore.
              </p>
            </em>
            <em>
              <p style={{ color: "#707070", marginBottom: 0 }}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Pariatur deleniti eveniet quas perferendis praesentium ab!
                Veniam, dignissimos similique neque tenetur nemo autem ut
                aliquid architecto.
              </p>
            </em>
          </TextBox>
          <img style={{ float: "right" }} src="/img/Group 27399.svg" alt="" />
          <CardAuthor>
            <Avatar src="/img/Mask Group 15.png" alt="" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h5>Juan Joe</h5>
              <p>
                <em>Lorem ipsum dolor.</em>
              </p>
            </div>
          </CardAuthor>
        </QueryCard>
        <QueryCard>
          <img src="/img/Group 27400.svg" alt="" />
          <TextBox>
            <p>
              <em>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet,
                dolore.
              </em>
            </p>
            <p style={{ color: "#707070", marginBottom: 0 }}>
              <em>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Pariatur deleniti eveniet quas perferendis praesentium ab!
                Veniam, dignissimos similique neque tenetur nemo autem ut
                aliquid architecto.
              </em>
            </p>
          </TextBox>
          <img style={{ float: "right" }} src="/img/Group 27401.svg" alt="" />
          <CardAuthor>
            <Avatar src="/img/Mask Group 16.png" alt="" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h5>Juan Joe</h5>
              <p>
                <em>Lorem ipsum dolor.</em>
              </p>
            </div>
          </CardAuthor>
        </QueryCard>
      </div>
      <div
        style={{
          marginTop: "4%",
          display: "flex",
          justifyContent: "center",
          paddingBottom: "4%",
        }}
      >
        <SeeMoreBtn>View More</SeeMoreBtn>
      </div>
    </Card>
  );
};

const SeeMoreBtn = styled.button`
  border: 2px solid #01d6c0;
  border-radius: 50px;
  font-weight: 600;
  background-color: #c5f0eb;
  padding: 1% 3%;

  &:hover {
    background-color: #01d6c0;
  }
`;

const Avatar = styled.img`
  margin-top: 4%;
  border-radius: 50%;
  margin-left: -8%;
  margin-bottom: -8%;
  height: 5rem;
  width: 5rem;
`;

const CardAuthor = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6%;
  & > div {
    margin-left: 10%;
  }

  & > div > h5 {
    font-weight: 600;
  }

  & > div > p {
    margin-bottom: 0;
    color: #707070;
  }
`;

const TextBox = styled.div`
  padding-inline: 12%;
`;

const Card = styled.div`
  padding: 2%;
  box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -webkit-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -moz-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  background-color: white;
`;

const QueryCard = styled.div`
  width: 40%;
  border: 1px solid black;
  border-radius: 30px;
  padding: 1.5%;
`;

export default HealthQuery;
